import { render, staticRenderFns } from "./DeclarationForm.vue?vue&type=template&id=05a860e3&scoped=true&"
import script from "./DeclarationForm.vue?vue&type=script&lang=js&"
export * from "./DeclarationForm.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationForm.vue?vue&type=style&index=0&id=05a860e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a860e3",
  null
  
)

export default component.exports